const comments = [
  {
    name: '星光影迷',
    time: '3 天前',
    text: '用了哈哈影院半年多了，资源真的全！不管是热播剧还是冷门老片基本都能找到，播放也不卡，比那些动不动就要会员的站强太多了。',
    rating: 5,
  },
  {
    name: '追剧小达人',
    time: '5 天前',
    text: '强烈推荐！更新速度飞快，昨晚播的剧第二天就有了，画质也很清晰。手机上看也方便，通勤路上追剧太爽了。',
    rating: 5,
  },
  {
    name: '电影老炮儿',
    time: '1 周前',
    text: '作为一个老影迷，哈哈影院的片库深度让我惊喜。很多冷门文艺片和经典黑白电影都能找到，画质修复得也不错，真心点赞。',
    rating: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            用户口碑
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5 border border-background-200/60">
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200/40">
                <span className="text-foreground-700 text-sm font-medium">{comment.name}</span>
                <span className="text-foreground-400 text-xs">{comment.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}